{
  "name": "hrp-app",
  "version": "1.38.126",
  "scripts": {
    "ng": "ng",
    "trace": "node --trace-warnings ./node_modules/@angular/cli/bin/ng serve",
    "start": "ng serve",
    "start-docker": "ng serve --configuration docker",
    "start-feature": "ng serve --configuration feature",
    "start-public": "ng serve --host 0.0.0.0",
    "build": "ng build --configuration development",
    "build-prod": "ng build --configuration production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test:hrp": "ng test hrp-app",
    "test:coverage": "ng test --watch=false --coverage --configuration=coverage-floor",
    "coverage:changed": "node tools/scripts/changed-coverage.mjs",
    "test:graphql": "ng test graphql",
    "test:page": "ng test page",
    "test:core": "ng test core",
    "test:ui": "ng test ui",
    "test:swagger": "ng test swagger",
    "graphql:codegen": "graphql-codegen --config codegen.ts",
    "openapi:humanresource": "ng-openapi-gen --config ng-openapi-gen/humanresources.json",
    "openapi:holidays": "ng-openapi-gen --config ng-openapi-gen/holiday.json",
    "openapi:contract": "ng-openapi-gen --config ng-openapi-gen/contracts.json",
    "storybook": "ng run hrp-app:storybook",
    "build-storybook": "ng run hrp-app:build-storybook",
    "lint": "ng lint",
    "lint:fix": "eslint --fix \"src/**/*.{ts,html}\"",
    "prepare": "husky && node tools/scripts/agent-config.mjs sync --prepare",
    "agents:sync": "node tools/scripts/agent-config.mjs sync",
    "agents:check": "node tools/scripts/agent-config.mjs check",
    "arch:paths": "node tools/scripts/sync-tsconfig-paths.mjs",
    "arch:slices": "node tools/scripts/check-slice-folders.mjs",
    "arch:sheriff": "node tools/scripts/sheriff-baseline.mjs",
    "arch:check": "node tools/scripts/sync-tsconfig-paths.mjs --check && npm run arch:slices && npm run arch:sheriff",
    "arch:detective": "detective --open false",
    "test:arch": "vitest run --config vitest.arch.config.ts",
    "verify:fast": "node tools/scripts/run-checks.mjs",
    "verify": "node tools/scripts/run-checks.mjs --full",
    "complexity": "node tools/scripts/complexity.mjs",
    "complexity:report": "node tools/scripts/complexity.mjs --hotspots --html src",
    "format": "prettier --check .",
    "browser:preflight": "node e2e/preflight.mjs",
    "test:e2e": "node e2e/preflight.mjs && playwright test",
    "test:e2e:types": "tsc -p e2e/tsconfig.json",
    "test:e2e:evidence": "node e2e/preflight.mjs && playwright test --trace on",
    "browser:lint": "eslint --config eslint.browser.config.mjs e2e playwright.config.ts eslint.browser.config.mjs .storybook/*.ts src/stories/add-contract-dialog.stories.ts src/stories/http-boundary.stories.ts",
    "browser:check": "npm run test:e2e:types && npm run storybook:types && npm run browser:lint",
    "storybook:types": "tsc -p .storybook/tsconfig.json --noEmit"
  },
  "private": true,
  "engines": {
    "node": "^24.16.0"
  },
  "dependencies": {
    "@angular-architects/ngrx-toolkit": "^21.0.0",
    "@angular/animations": "^21.1.0",
    "@angular/cdk": "^21.1.0",
    "@angular/cli": "^21.1.0",
    "@angular/common": "^21.1.0",
    "@angular/compiler": "^21.1.0",
    "@angular/core": "^21.1.0",
    "@angular/forms": "^21.1.0",
    "@angular/platform-browser": "^21.1.0",
    "@angular/platform-browser-dynamic": "^21.1.0",
    "@angular/router": "^21.1.0",
    "@angular/service-worker": "^21.1.0",
    "@apollo/client": "^4.1.0",
    "@date-fns/tz": "^1.5.0",
    "@jsverse/transloco": "^8.2.0",
    "@ng-icons/core": "^33.2.2",
    "@ng-icons/lucide": "^33.2.2",
    "@ng-icons/material-file-icons": "^33.2.2",
    "@ng-icons/material-icons": "^33.2.2",
    "@ng-icons/material-symbols": "^33.2.2",
    "@ngneat/effects": "^2.1.2",
    "@ngneat/effects-ng": "^3.1.3",
    "@ngneat/elf": "^2.5.1",
    "@ngneat/elf-entities": "^5.0.1",
    "@ngneat/elf-pagination": "^1.1.0",
    "@ngneat/elf-persist-state": "^1.2.0",
    "@ngneat/elf-requests": "^1.9.2",
    "@ngrx/component-store": "^21.0.1",
    "@ngrx/effects": "^21.0.1",
    "@ngrx/entity": "^21.0.1",
    "@ngrx/operators": "^21.0.1",
    "@ngrx/signals": "^21.0.1",
    "@ngrx/store": "^21.0.1",
    "@ngrx/store-devtools": "^21.0.1",
    "@paragondata/ngx-config": "^21.0.0",
    "@paragondata/ngx-signalr": "^21.0.1",
    "@tailwindcss/container-queries": "^0.1.1",
    "angular-oauth2-oidc": "^20.0.2",
    "angular-oauth2-oidc-jwks": "^20.0.0",
    "angular-resizable-element": "^8.0.1",
    "apollo-angular": "^13.0.0",
    "date-fns": "^4.1.0",
    "graphql": "^16.6.0",
    "ios-pwa-splash": "^1.0.0",
    "lodash": "^4.17.21",
    "moment": "^2.29.4",
    "ng-openapi-gen": "^0.50.2",
    "rxjs": "~7.8.1",
    "tailwindcss": "^3.3.2",
    "ts-node": "^10.9.1",
    "tslib": "^2.3.0",
    "tus-js-client": "^4.3.1",
    "uuid": "^11.0.0",
    "zod": "^4.3.5",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^21.1.0",
    "@angular-eslint/eslint-plugin": "^21.1.0",
    "@angular-eslint/eslint-plugin-template": "^21.1.0",
    "@angular-eslint/schematics": "^21.1.0",
    "@angular-eslint/template-parser": "^21.1.0",
    "@angular/build": "^21.1.0",
    "@angular/compiler-cli": "^21.1.0",
    "@chromatic-com/storybook": "^5.0.0",
    "@compodoc/compodoc": "2.0.0",
    "@eslint/eslintrc": "^3.3.3",
    "@eslint/js": "^9.39.2",
    "@graphql-codegen/cli": "^6.1.1",
    "@graphql-codegen/typescript": "^5.0.7",
    "@graphql-codegen/typescript-apollo-angular": "^4.0.1",
    "@graphql-codegen/typescript-operations": "^5.0.7",
    "@ngneat/elf-devtools": "^1.3.0",
    "@ngneat/spectator": "^22.1.0",
    "@playwright/test": "1.64.0",
    "@softarc/detective": "^2.1.2",
    "@softarc/eslint-plugin-sheriff": "^0.19.6",
    "@softarc/sheriff-core": "^0.19.6",
    "@storybook/addon-docs": "^10.1.11",
    "@storybook/addon-links": "^10.1.11",
    "@storybook/addon-onboarding": "^10.1.11",
    "@storybook/angular": "^10.1.11",
    "@tailwindcss/forms": "^0.5.2",
    "@tailwindcss/line-clamp": "^0.4.0",
    "@types/lodash": "^4.14.168",
    "@types/node": "^22.9.1",
    "@types/react": "^18.0.27",
    "@types/uuid": "^9.0.2",
    "@typescript-eslint/eslint-plugin": "^8.53.1",
    "@typescript-eslint/parser": "^8.53.1",
    "@typescript-eslint/utils": "^8.53.1",
    "@vitest/coverage-v8": "^4.1.11",
    "archunit": "^2.5.4",
    "autoprefixer": "^10.4.7",
    "eslint": "^9.0.0",
    "eslint-config-prettier": "^10.0.1",
    "eslint-plugin-prettier": "^5.2.3",
    "eslint-plugin-sonarjs": "^4.2.2",
    "eslint-plugin-storybook": "^10.1.11",
    "husky": "^9.1.7",
    "jsdom": "^30.1.2",
    "lint-staged": "^16.2.7",
    "ng-packagr": "^21.1.0",
    "postcss": "^8.4.14",
    "postcss-import": "^15.0.0",
    "prettier": "^3.8.0",
    "storybook": "^10.1.11",
    "typescript": "~5.9.3",
    "vitest": "^4.1.11"
  },
  "optionalDependencies": {
    "@rollup/rollup-linux-x64-gnu": "*"
  }
}
